// Автообновление вкладки «Задания»: один тик опроса раз в STATUS_POLL_INTERVAL_MS. Логика вне
// TasksManager.jsx, чтобы её можно было проверить без рендера.

// Skipped считается терминальным: конвейер его не трогает, а кнопка «Переобработать»
// в строке должна быть доступна — это и есть принудительная обработка звонка.
export const TERMINAL_TASK_STATUSES = new Set(['Completed', 'Failed', 'Skipped']);

export const selectActiveTasks = (tasks) =>
  (tasks ?? []).filter((task) => task?.status && !TERMINAL_TASK_STATUSES.has(task.status));

/** Новый массив: у строк из updatesById заменены status и updatedAt, остальные — те же объекты. */
export const applyStatusUpdates = (tasks, updatesById) =>
  tasks.map((task) => {
    const update = updatesById.get(task.id);
    return update ? { ...task, status: update.status, updatedAt: update.updatedAt } : task;
  });

/**
 * Один тик опроса: статусы незавершённых заданий страницы и сводка «Состояние очереди».
 *
 * Сводка перечитывается на каждом тике, что бы ни лежало на странице. Она считается по всей
 * выборке за период, а страница тиком не перечитывается: новые задания из телефонии на неё не
 * попадают. Раньше сводка обновлялась только при незавершённых заданиях на странице, и на
 * странице из обработанных «Последняя проверка» тикала, а счётчики стояли до перезагрузки.
 */
export const runTaskStatusPoll = async ({
  tasks,
  fetchStatus,
  normalizeStatus,
  applyUpdates,
  reloadTasks,
  loadSummary
}) => {
  const activeTasks = selectActiveTasks(tasks);
  const updatesById = new Map();

  if (activeTasks.length > 0) {
    const responses = await Promise.allSettled(activeTasks.map((task) => fetchStatus(task.id)));
    responses.forEach((result) => {
      if (result.status === 'fulfilled' && result.value) {
        updatesById.set(result.value.id, {
          ...result.value,
          status: normalizeStatus(result.value.status)
        });
      }
    });
  }

  if (updatesById.size > 0) {
    applyUpdates(updatesById);
  }

  const becameTerminal = activeTasks.some((task) => {
    const update = updatesById.get(task.id);
    return update && TERMINAL_TASK_STATUSES.has(update.status) && task.status !== update.status;
  });

  // Завершившееся задание меняет фильтры и счётчики страницы — её перечитываем целиком,
  // а сводку перечитывает сама загрузка страницы.
  if (becameTerminal) {
    await reloadTasks();
    return;
  }

  await loadSummary();
};
